import { render } from "./PlayerInTeam.vue?vue&type=template&id=46f91ca8&scoped=true"
import script from "./PlayerInTeam.vue?vue&type=script&lang=js"
export * from "./PlayerInTeam.vue?vue&type=script&lang=js"

import "./PlayerInTeam.vue?vue&type=style&index=0&id=46f91ca8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f91ca8"]])

export default __exports__